import supabase from "../../../shared/database/supabase";
import { safeArray } from "../../../shared/lib/response-validation/safe-array";
import { PericiaNotes } from "../model/pericia-notes";

export interface ListPericiaNotesRequest {
  id_pericia: string;
}

export const listPericiaNotes = async (req: ListPericiaNotesRequest): Promise<PericiaNotes[]> => {
  try {
    const { data, error } = await supabase.functions.invoke("list-pericia-notes", {
      body: JSON.stringify(req)
    });

    if (error) throw error;
    const notes = safeArray<PericiaNotes>(data?.notes, "list-pericia-notes.notes");

    return notes.map((periciaNote) => ({
      ...periciaNote,
      createdAt: new Date(periciaNote.createdAt),
      updatedAt: new Date(periciaNote.updatedAt)
    }));
  } catch (err) {
    console.log(err);
    throw err;
  }
};
